import { createContext, useReducer } from "react";

export const PrintStore = createContext<IContextProps>(null);

interface IContextProps {
  state: IState;
  dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type; payload };
class Search {
  keywords: string;
  classesId: string[] = [];
  statusId: string;
  typeId: string;
  brandId: string;
}

interface IState {
  classesList: any[];
  statusList: any[];
  typeList: any[];
  brandList: any[];
  search: Search;
}

const initialArgs: IState = {
  classesList: [],
  statusList: [],
  typeList: [],
  brandList: [],
  search: new Search(),
};

function reducer(state: IState, { type, payload }: Dispatch) {
  switch (type) {
    case "LoadClasses":
      return {
        ...state,
        classesList: payload,
      };
    case "LoadStatus":
      return {
        ...state,
        statusList: payload,
      };
    case "LoadType":
      return {
        ...state,
        typeList: payload,
      };
    case "LoadBrand":
      return {
        ...state,
        brandList: payload,
      };
    case "SetSearch":
      return {
        ...state,
        search: {
          ...state.search,
          ...payload,
        },
      };
    default:
      return state;
  }
}

export function PrintStoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialArgs);

  const v: any = { state, dispatch };
  return <PrintStore.Provider value={v}>{props.children}</PrintStore.Provider>;
}
